import setExplicitLogonHeaders from './setExplicitLogonHeaders';
import { MailboxInfo } from 'owa-client-ids';
import { RequestOptions } from './types/RequestOptions';

export default function createExplicitLogonRequest(
    smtp: string,
    mailboxInfo: MailboxInfo
): RequestOptions {
    const req: RequestOptions = mailboxInfo.requestOptions ? mailboxInfo.requestOptions : {};
    const headers = req.headers && req.headers.set ? req.headers : new Headers();
    setExplicitLogonHeaders(smtp, <Headers>headers);
    return {
        ...req,
        headers,
    };
}
